module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto-form"
  }, [(_vm.title) ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('el-form', {
    ref: "form",
    staticClass: "ui form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_vm._l((_vm.defines.form.layout), function(row) {
    return _c('div', {
      class: _vm.fields_classes(row)
    }, [_vm._l((row), function(key) {
      return [_c('el-form-item', {
        staticClass: "ui field",
        class: {
          required: _vm.prop(key).required, disabled: _vm.prop(key).$readonly(_vm.form)
        },
        attrs: {
          "prop": key
        }
      }, [_c('label', [_vm._v(_vm._s(_vm.prop(key).label)), (_vm.prop(key).note) ? _c('span', [_vm._v(_vm._s(_vm.prop(key).note))]) : _vm._e()]), (_vm.prop(key).type === "select") ? [_c('el-select', {
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      }, _vm._l((_vm.prop(key).$select(_vm.form)), function(item) {
        return _c('el-option', {
          key: item.key,
          attrs: {
            "label": item.label,
            "value": item.key
          }
        })
      }))] : (_vm.prop(key).type === "number" || _vm.prop(key).type === "money") ? [_c('el-input-number', {
        attrs: {
          "min": _vm.prop(key).min,
          "max": _vm.prop(key).max,
          "controls": _vm.prop(key).controls || false
        },
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      })] : (_vm.prop(key).type === "virtual") ? [_c('el-input', {
        attrs: {
          "value": _vm.prop(key).$value(_vm.form)
        },
        on: {
          "change": function (value) { return _vm.prop(key).setter(value, _vm.form); }
        }
      })] : (_vm.prop(key).type === "check") ? [_c('br'), _c('el-checkbox', {
        attrs: {
          "label": _vm.prop(key).label
        },
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      })] : (_vm.prop(key).type === "time") ? [_c('datepicker', {
        attrs: {
          "label": _vm.prop(key).label
        },
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      })] : (_vm.prop(key).type === "autocomplete") ? [_c('el-autocomplete', {
        attrs: {
          "fetch-suggestions": _vm.prop(key).suggestions(_vm.form)
        },
        on: {
          "select": function (item) { return _vm.suggestions_handler(item, _vm.prop(key), key); }
        },
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      })] : [_c('el-input', {
        model: {
          value: (_vm.form[key]),
          callback: function($$v) {
            _vm.$set(_vm.form, key, $$v)
          },
          expression: "form[key]"
        }
      })]], 2)]
    })], 2)
  }), (_vm.buttons) ? _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.action_primary
    }
  }, [_vm._v(_vm._s(_vm.text_primary))]), (_vm.buttonReset) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]) : _vm._e(), (_vm.buttonCancel) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.action_cancel
    }
  }, [_vm._v(_vm._s(_vm.text_cancel))]) : _vm._e()]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68484e3c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/auto/AutoForm.vue
// module id = 336
// module chunks = 0